import { Routes, Route } from 'react-router-dom';
import { TicketListPage } from './TicketListPage';
import { TicketDetailPage } from './TicketDetailPage';

export default function SupportPage() {
  return (
    <Routes>
      <Route index element={<TicketListPage />} />
      <Route path=":ticketId" element={<TicketDetailPage />} />
    </Routes>
  );
}
